<template>
  <v-container>
    <v-dialog
      v-model="signUpDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          :color="appColour">
          <v-btn
            icon
            dark
            @click="closeSignUpDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Sign Up</v-toolbar-title>
        </v-toolbar>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data: () => ({

  }),

  components: {

  },
  props: {
    signUpDialog: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState(['parentName', 'userId', 'trueUser', 'pupilId']),
    appColour () { return this.$store.state.appColour }

  },

  mounted: function () {
  },

  methods: {
    closeSignUpDialog: function () {
      this.$emit('closeSignUp')
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)
    })
  }
}
</script>
